import { useRef, useEffect } from 'react';

export class AudioPlayer {
  audios: Record<string, HTMLMediaElement>;
  playingId: string | undefined;

  constructor() {
    this.audios = {};
    this.playingId = undefined;
  }

  async loadAudio(id: string, url: string) {
    if (!this.audios[id]) {
      const audio = new Audio(url);
      this.audios[id] = audio;
      await new Promise<void>((resolve) => {
        audio.addEventListener('canplaythrough', () => {
          resolve();
        });
      });
    }
  }

  playAudio(id: string) {
    this.stopAudio();

    const audio = this.audios[id];
    if (audio) {
      this.playingId = id;
      audio.play().catch(console.error);
    }
  }

  stopAudio() {
    if (this.playingId !== undefined) {
      const audio = this.audios[this.playingId];
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
      this.playingId = undefined;
    }
  }

  reset() {
    this.stopAudio();
    this.audios = {};
  }
}

/**
 * Hook to return an audio player
 * @returns audio player
 */
const useAudioPlayer = () => {
  const ref = useRef<AudioPlayer>(new AudioPlayer());

  useEffect(() => {
    const audioPlayer = ref.current;
    return () => {
      audioPlayer.reset();
    };
  }, []);

  return ref.current;
};

export default useAudioPlayer;
